import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { fetchLanguages } from "@/redux/slice/language/languages";
import { useLanguageContext } from "@/contexts/language-context";
import { Icon } from "@/components";
import "./header.scss";

interface headerProp {
  setModalState?: React.Dispatch<React.SetStateAction<boolean>>;
  modalState?: Boolean;
}

export default function Header({ setModalState, modalState }: headerProp) {
  const { details, token } = useAuth();
  const dispatch = useAppDispatch();
  const { values, updateLanguage, setAvailableLanguages, resetLanguage } = useLanguageContext();
  const [searchText, setSearchText] = useState("");

  const { data, loading } = useAppSelector((state) => state.languages);

  useEffect(() => {
    if (token && (!data || data.length === 0)) {
      dispatch(
        fetchLanguages({
          token: token,
          updateLanguages: (languages) => setAvailableLanguages(languages.map((lang) => lang.name)),
        })
      );
    }
  }, [token, dispatch, setAvailableLanguages, data]);

  const filteredLanguages = values.availableLanguages.filter((language) =>
    language.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="header">
      <h1 className="greeting">
        {details ? `Hi, ${details.firstName} ${details.lastName}` : "Hi"}
      </h1>
      <div>
        <div className="description">
          <Link to="/notification">
            <Icon name="message" />
          </Link>
          <div
            className="language-and-arrow"
            onClick={() => {
              setModalState && setModalState(!modalState);
            }}
          >
            <div>{values.initialLanguage || "Select"}</div>
            <Icon name="downArrow" />
          </div>
        </div>
      </div>
    </div>
  );
}
